export default __webpack_public_path__ + "static/media/icons-member-vote.c3cf35bb.svg";